import * as React from 'react'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject } from 'mobx-react'
import { Button } from 'react-bootstrap'
import Setting, { UISettingUpdateFormSchema, getSettingUpdateFormSchema } from '../../../Model/Setting'
import HttpActionsService from '../../../Services/HttpActionsService'

export interface ISettingUpdateViewProps {
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
}

@inject('localizationStore')
@inject('httpActionsService')
export default class SettingUpdateView extends React.Component<ISettingUpdateViewProps> {

    uiSchema: any = UISettingUpdateFormSchema

    render() {

        const { localizationStore, httpActionsService } = this.props

        return (
            <div className="setting-update-view">
                <Form
                    onSubmit={(e: ISubmitEvent<any>) => {
                        httpActionsService!.createOrUpdateSetting(new Setting(e.formData['key'], e.formData['value']))
                    }
                    }
                    schema={getSettingUpdateFormSchema()}
                    uiSchema={this.uiSchema}
                >
                    <div className="modalFormBtns">
                        <Button className="submitUpdateSetting" type="submit">{localizationStore!.t!('Ok')}</Button>
                    </div>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Settings/SettingUpdateView.tsx